module.exports = __webpack_public_path__ + "media/images/flags/VI-149e04634230401e1d716bd0f3794cf0.svg";